export const formUtil = {
    parseQuestionFormat: (question) => {
        const questionType = formUtil.parseQuestionType(question);

        if (questionType == 'OPEN_RESPONSE_NAME' || questionType == 'OPEN_RESPONSE_EMAIL' || questionType == 'OPEN_RESPONSE_LONG' || questionType == 'OPEN_RESPONSE_SHORT') {
            return 'text';
        }
        else if (questionType == 'OPEN_RESPONSE_PHONE') {
            return 'number';
        }
        else if (questionType == 'OPEN_RESPONSE_DATE') {
            return 'date';
        }
        else if (questionType == 'OPEN_RESPONSE_TIME') {
            return 'time';
        }
        else if (questionType == 'YES_NO') {
            return 'boolean';
        }
        else if (questionType == 'MULTIPLE_CHOICE_SINGLE_ANSWER') {
            return 'text';
            // return 'number';
        }
        else if (questionType == 'MULTIPLE_CHOICE_MULTIPLE_ANSWER') {
            // return 'numberArray';
            return 'stringArray';
        }
        else if (questionType == 'SIGNATURE') {
            return 'text';
        }
    },
    convertFormAnswerList: (question, textMode) => {
        const questionType = formUtil.parseQuestionType(question);

        const answers = question.formAnswerList.map((a) => {
            let answer = null;
            if (questionType == 'OPEN_RESPONSE_NAME' || questionType == 'OPEN_RESPONSE_EMAIL' 
                || questionType == 'OPEN_RESPONSE_LONG' || questionType == 'OPEN_RESPONSE_SHORT'
                || questionType == 'SIGNATURE' ) {
                answer = a.answerText;
            }
            else if (questionType == 'OPEN_RESPONSE_PHONE') {
                answer = a.answerNumber;
            }
            else if (questionType == 'OPEN_RESPONSE_DATE') {
                answer = a.answerDate;
            }
            else if (questionType == 'OPEN_RESPONSE_TIME') {
                answer = a.answerTime;
            }
            else if (questionType == 'YES_NO') {
                if(textMode){
                    answer = a.answerText;
                }
                else{
                    if(a.answerText){
                        answer = a.answerText.toUpperCase() == 'YES' || a.answerText.toUpperCase() == 'TRUE'  ? 0:1
                    }
                }
            }
            else if (questionType == 'MULTIPLE_CHOICE_SINGLE_ANSWER') {
                if(textMode){
                    answer = a.answerText;
                }
                else{
                    //return the index of the question options
                    const answerIndex = question.formMultipleChoiceQuestionOptionsList.findIndex(o => o.options == a.answerText);
                    if(answerIndex >= 0){
                        answer = answerIndex;
                    }
                    else{
                        answer = null
                    }
                }
            }
            else if (questionType == 'MULTIPLE_CHOICE_MULTIPLE_ANSWER') {
                let answerArray = [];
                if(a.answerText){
                    answerArray = JSON.parse(a.answerText);
                }

                if(textMode){
                    if(a.answerText){
                        answer = answerArray.join(', ');
                    }
                    else{
                        answer = '';
                    }
                }
                else{
                    answer = answerArray;
                }
            }

            return answer;
        });

        return answers[0];
    },
    parseQuestionType: (question) => {
        let type = 'OPEN_RESPONSE_SHORT';
        
        if(question && question.questionType){
            type = question.questionType;
            if(type === 'PROFILE'){
              const mappingType = question.profileMapping.type;
              if(mappingType){
                type = mappingType;
              }
              else{
                type = 'OPEN_RESPONSE_SHORT';
              }
            }
        }

        return type;
      }
}